import React, {useEffect, useState} from 'react';
import {user_data} from "../../../../../../../../components/functions/usr";
import axios from "axios";
import {header} from "../../../../../../../../components/api/Header";
import {addFunc, bolFunc, fixIt} from "../../../../../../../../components/functions/Mathematik";
import decade_days from "../../../../../../../../components/sfr/maydon";
import Info from "./Info";
import { getEnv } from "../../../../../../../../lib/env";

function Xisobot3(props) {
    const year = localStorage.getItem('sfr-hm-year')
    const user = user_data()
    const season = localStorage.getItem('sfr-hm-season')
    const [types, setTypes] = useState([])
    const manba = localStorage.getItem("sfr-hm-manbalar")
    const manbalar = manba?JSON.parse(manba):[]
    const ist = localStorage.getItem("sfr-hm-istemolchilar")
    const istemolchilar = ist?JSON.parse(ist):[]
    const may = localStorage.getItem("sfr-hm-"+season+"-maydon")
    const maydon = may?JSON.parse(may):[]
    const ste_module = localStorage.getItem('sfr-hm-ste')
    const ste = ste_module?JSON.parse(ste_module):null
    const days = decade_days(season,year)
    const crops1 = localStorage.getItem('sfr-hm-'+season+'-ekinids')
    const cropids = crops1?JSON.parse(crops1):{}
    const [sm, setSm] = useState({})
    const [yonalishlar, setYonalishlar] = useState([])
    let jami_maydon = 0
    let jami_talab = 0
    let jami_mlnm3 = 0

    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/ekintypes?crops="+cropids,header())
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setTypes(res.data)
            }
        }
        const fetchSm = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/noveg_sugorish_meyyori?crops="+cropids,header())
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setSm(res.data)
            }
        }
        const fetchYonalishlar = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/yonalishlar",header())
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setYonalishlar(res.data)
            }
        }
        fetchData()
        fetchSm()
        fetchYonalishlar()
    },[])
    const _helper = (arr,mid,sum=false) => {
        if(arr.length){
            let maydonlar = 0
            let talabesm = 0
            let mlnm3 = 0
            arr.map(e=>{
                if(Object.values(maydon).length){
                    Object.keys(maydon).map(ist=> {
                        const a = istemolchilar.filter(is => is.id == ist.slice(1,))
                        if(a.length){
                            if (a[0].mid && a[0].mid == mid || sum) {
                                var em = 0
                                var gxsm = 0
                                var etesm = 0
                                if (Object.values(maydon[ist]).length) {
                                    Object.keys(maydon[ist]).map(gm => {
                                        if (maydon[ist][gm]) {
                                            if (maydon[ist][gm]['e' + e.id] > 0) {
                                                em = addFunc(em, maydon[ist][gm]['e' + e.id]) // istemolchi va gidromodul kesimida gektar
                                                var jsm = sm[gm.slice(1,) + '_' + e.id] ? sm[gm.slice(1,) + '_' + e.id] : 0 //ekinning gidromodul boyicha sugorish meyorlari jami
                                                var netto = jsm * maydon[ist][gm]['e' + e.id] // jami sugorish meyyori * gektar (istemolchi va gidromodul kesimida)
                                                gxsm = addFunc(gxsm, netto)
                                            }
                                        }
                                    })
                                }
                                // var netto1 = gxsm / em
                                // etesm = netto1 * em / 1000000 // => (gxsm / em) * em / 1000000 =>  gxsm / 1000000
                                etesm = bolFunc(gxsm, 1000000) // jami sugorish maydon * gektar lar yig'indisini gektarlar yig'indisiga bo'lish
                                talabesm = addFunc(talabesm, etesm)
                                maydonlar = addFunc(maydonlar, em)
                                //manba fikini aniqlash
                                var manba_id = istemolchilar.filter(is => is.id == ist.slice(1,))[0].mid // manba_idsi
                                var fik = manbalar.filter(m => m.id == manba_id)[0].fik // ist i1/i2 => 1/2
                                mlnm3 = addFunc(mlnm3, etesm / fik)
                            }
                        }
                    })
                }
            })
            return [maydonlar,talabesm,mlnm3]
        }
    }
    const _ste_xisobi = (yonalish, mid,sum=false) => {
        if(!ste){
            return[0,0]
        }
        const yonalishlararr = ste.filter(s=>s.yonalish==yonalish)
        let res2 = 0
        let res3 = 0

        if(yonalishlararr.length){
            yonalishlararr.map(y=>{
                if(y.manba == mid || sum){
                    let res1 = 0
                    for(var i = 1; i < 19; i++){
                        res1 = addFunc(res1,(y['d'+i] * (0.0864*days['d'+i])))
                    }
                    res1 = res1 / 1000
                    res3 = addFunc(res3,res1)
                    const fik = manbalar.filter(m=>m.id==y.manba)[0].fik
                    res2 = addFunc(res2,(res1/fik))
                }
            })
        }
        return [res3,res2]
    }

    const xisobot = () => {
        let obj = [];
        if (types.length) {
            types.map((t, index) => {
                const r = _helper(t.ekin, 0,true)
                if (t.grouped) {
                    obj.push(
                        <tbody key={index + "jgr"}>
                        <tr>
                            <th className="text-start">{t.name} - jami</th>
                            <th>{fixIt(r[0])}</th>
                            <th>{fixIt(bolFunc((r[1] * 1000000), r[0]),0)}</th>
                            <th>{fixIt(r[1],3)}</th>
                            <th>{fixIt(bolFunc(r[1], r[2]),3)}</th>
                            <th>{fixIt(r[2],3)}</th>
                        </tr>
                        <tr>
                            <td>shu jumladan</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        </tbody>
                    )
                }
                if (t.ekin) {
                    if (t.ekin.length) {
                        t.ekin.map((e, i) => {
                            const r = _helper([e], 0,true)
                            jami_maydon = addFunc(jami_maydon, r[0])
                            jami_talab = addFunc(jami_talab, r[1])
                            jami_mlnm3 = addFunc(jami_mlnm3, r[2])
                            obj.push(
                                <tbody key={index + 'je' + i}>
                                <tr>
                                    <td className="text-start">{e.name}</td>
                                    <td>{fixIt(r[0])}</td>
                                    <td>{fixIt(bolFunc((r[1] * 1000000), r[0]),0)}</td>
                                    <td>{fixIt(r[1],3)}</td>
                                    <td>{fixIt(bolFunc(r[1], r[2]))}</td>
                                    <td>{fixIt(r[2],3)}</td>
                                </tr>
                                </tbody>
                            )
                        })
                    }
                }
            })
        }
        const soga = _ste_xisobi(6, 0, true)
        let j_ste = [0, 0];
        if (yonalishlar.length) {
            yonalishlar.map(y => {
                const res = _ste_xisobi(y.id, 0,true)
                j_ste[0] = addFunc(j_ste[0], res[0])
                j_ste[1] = addFunc(j_ste[1], res[1])
            })
        }

        obj.push(
            <tbody key="u-jami-sugorish">
            <tr style={{background: "#cecccc"}}>
                <th style={{minWidth: '300px'}}><i>Jami</i></th>
                <th>{jami_maydon}</th>
                <td>{fixIt(bolFunc((jami_talab * 1000000), jami_maydon),0)}</td>
                <td>{fixIt(jami_talab)}</td>
                <td>{fixIt(bolFunc(jami_talab, jami_mlnm3))}</td>
                <td>{fixIt(jami_mlnm3)}</td>
            </tr>
            <tr>
                <th className="text-start">Suv omborlarini to'ldirishga</th>
                <th></th>
                <th></th>
                <th>{fixIt(soga[0])}</th>
                <th>{fixIt(bolFunc(soga[1], soga[0]))}</th>
                <th>{fixIt(soga[1])}</th>
            </tr>
            <tr>
                <th className="text-start">Jami sanoat texnik extiyojlar</th>
                <th></th>
                <th></th>
                <td>{fixIt(j_ste[0])}</td>
                <td>{fixIt(bolFunc(j_ste[0], j_ste[1]))}</td>
                <td>{fixIt(j_ste[1])}</td>
            </tr>
            </tbody>
        )
        if (yonalishlar.length) {
            yonalishlar.map(y => {
                const res = _ste_xisobi(y.id, 0, true)
                obj.push(
                    <tbody key={y.id}>
                    <tr>
                        <td className="text-start">{y.yonalish}</td>
                        <td></td>
                        <td></td>
                        <td>{fixIt(res[0])}</td>
                        <td>{fixIt(bolFunc(res[0], res[1]))}</td>
                        <td>{fixIt(res[1])}</td>
                    </tr>
                    </tbody>
                )
            })
        }
        jami_talab = addFunc(jami_talab, j_ste[0])
        jami_mlnm3 = addFunc(jami_mlnm3, j_ste[1])
        obj.push(
            <tbody key="jami">
            <tr style={{background:"#b0acac"}}>
                <th>Jami {user.district} bo'yicha</th>
                <th>{jami_maydon}</th>
                <td>{fixIt(bolFunc((jami_talab * 1000000), jami_maydon),0)}</td>
                <td>{fixIt(jami_talab)}</td>
                <td>{fixIt(bolFunc(jami_talab, jami_mlnm3))}</td>
                <td>{fixIt(jami_mlnm3)}</td>
            </tr>
            </tbody>
        )
        return obj;
    }
    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-borderless m-0">
                    <thead>
                    <tr>
                        <td><h4 className="text-center">Xisobot - №2</h4></td>
                    </tr>
                    <tr>
                        <td>
                            <h5 className="text-center px-5">{user.district}ning {year} - {parseInt(year)+1} yilning kuzgi-qishki davriga talab etiladigan suv miqdori va olinadigan suvning <br/> Hisob - kitobi</h5>
                        </td>
                    </tr>
                    </thead>
                </table>
                <div className="flex-box xisobot-table">
                    <div className="xisobotTable">
                        <table className="table table-bordered text-center xisobot3">
                            <thead className="sticky-top" style={{background:"#77adba",color:"#fff"}}>
                            <tr>
                                <th>Ko'rsatgichlar</th>
                                <th>Fizik maydon, ga</th>
                                <th>Sug'orish rejimi asosida sug'orish meyyori (netto), m<sup>3</sup>/ga</th>
                                <th>Talab etiladigan suv miqdori (netto), mln.m<sup>3</sup></th>
                                <th>Tizim FIK (KPD) (xo'jalik-aro, ichki xo'jalik)</th>
                                <th>Sug'orish tizimlaridan jami talab etiladigan suv miqdori (brutto) mln.m<sup>3</sup></th>
                            </tr>
                            </thead>
                            {xisobot()}
                        </table>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-2">
                <Info />
            </div>
        </div>
    );
}

export default Xisobot3;